import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SublimeToolbar',
  props: {
    height: { default: null },
    dense: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { height: string | number | null, dense: boolean };



const calcHeight = computed(() => {
    if (props.height) {
        return props.height;
    }
    if (props.dense) {
        return '36px';
    }
    return '48px';
});

return { __sfc: true,props, calcHeight }
}

})